export const HOME = {
  emergentLink: "home-emergent-link",
  registerBtn: "home-register-btn",
  scheduleBtn: "home-schedule-btn",
  directoryBtn: "home-directory-btn",
  toolkitBtn: "home-toolkit-btn",
  detailsBtn: "home-details-btn",
  contactBtn: "home-contact-btn",
  loginBtn: "home-login-btn",
};

export const AUTH = {
  emailInput: "auth-email-input",
  sendLinkBtn: "auth-send-link-btn",
  magicLinkResult: "auth-magic-link-result",
  attendeeTab: "auth-attendee-tab",
  exhibitorTab: "auth-exhibitor-tab",
  accessCodeInput: "auth-access-code-input",
  attendeeNameInput: "auth-attendee-name-input",
  attendeeEmailInput: "auth-attendee-email-input",
  attendeeSubmit: "auth-attendee-submit-btn",
  logoutBtn: "auth-logout-btn",
};

export const REG = {
  companyName: "reg-company-name",
  primaryContact: "reg-primary-contact",
  email: "reg-email",
  phone: "reg-phone",
  website: "reg-website",
  industry: "reg-industry",
  description: "reg-description",
  certifications: "reg-certifications",
  productsServices: "reg-products-services",
  agreeTerms: "reg-agree-terms",
  submit: "reg-submit-btn",
  nextStep: "reg-next-step-btn",
  prevStep: "reg-prev-step-btn",
};

export const DASH = {
  payNowBtn: "dash-pay-now-btn",
  uploadLogoBtn: "dash-upload-logo-btn",
  uploadBackwallBtn: "dash-upload-backwall-btn",
  uploadCapabilityBtn: "dash-upload-capability-btn",
  saveProfileBtn: "dash-save-profile-btn",
};

export const ADMIN = {
  exportCsv: "admin-export-csv-btn",
  approveBtn: "admin-approve-btn",
  rejectBtn: "admin-reject-btn",
  paymentToggleBtn: "admin-payment-toggle-btn",
  newAnnouncementBtn: "admin-new-announcement-btn",
  announcementSubmit: "admin-announcement-submit-btn",
  magicLinksTab: "admin-magic-links-tab",
};
